import React from "react";
import Button from "@material-ui/core/Button";
import Typography from "@material-ui/core/Typography";
import WarningIcon from "@material-ui/icons/Warning";
import useStyles from "../../models/buttons/buttonStyles";
import VarianceMismatchDialog from "./VarianceMismatchDialog";

const VarianceMismatchButton = ({ row, onRefreshData }) => {
  const classes = useStyles(); 
  const [open, setOpen] = React.useState(false);

  return (
    <React.Fragment>
      <Button
        disableElevation
        disableFocusRipple
        disableRipple
        className={classes.button}
        onClick={() => setOpen(true)}
      >
        <div className={classes.logo} style={{ width: "auto" }}>
         
          &nbsp;
          <Typography variant="body1">Review Variance/Mismatch</Typography>
        </div>
      </Button>

      <VarianceMismatchDialog
        open={open}
        handleClose={() => setOpen(false)}
        row={row}
        onRefreshData={onRefreshData}
      />
    </React.Fragment>
  );
};

export default VarianceMismatchButton;
